module.exports = __webpack_public_path__ + "img/thinking-process-waiting.83f31b2.gif";